import React from 'react';
import { useParams } from 'react-router-dom';

import { useSportState } from '@atlas/core';

import SportCategoryFilter from 'components/Pages/Live/SportCategoryFilter';
import { DefaultSportsbookNavigation } from 'components/Pages/SportsbookNavigation';

import LiveSportsbookLoader from '../LiveSportsbookLoader';

import CategoryFilterOption from './CategoryFilterOption';
import { LiveCategoriesList } from './LiveCategoriesList';

const LiveCategoriesView = () => {
  const { categories } = useSportState();
  const { categoryName } = useParams();

  const [clickedCategory, setClickedCategory] = React.useState(null);
  const [expandedCategory, setExpandedCategory] = React.useState(0);

  const onClickHandler = () => {
    setExpandedCategory(expandedCategory => expandedCategory + 1);
  };
  return (
    <DefaultSportsbookNavigation path="/live">
      <LiveSportsbookLoader>
        <SportCategoryFilter
          ItemComponent={CategoryFilterOption}
          clickedCategory={clickedCategory}
          onClick={onClickHandler}
          options={categories}
          setClickedCategoryId={clickedCategory => () => setClickedCategory(clickedCategory)}
          value={categoryName || ''}
          valueProperty="urlName"
        />
        <h2 className="d-none">{categoryName}</h2>
        <LiveCategoriesList
          categories={categories}
          clickedCategory={clickedCategory}
          expandedCategory={expandedCategory}
          isAllCategoriesExpanded
        />
      </LiveSportsbookLoader>
    </DefaultSportsbookNavigation>
  );
};

export default LiveCategoriesView;
